<template>
  <div>
    <router-link to="/workspace/members">
      <h5 class="text-primary">
        <i class="mdi mdi-chevron-left font-size-24 align-middle"></i>
        {{ $t("workspace.members") }}
      </h5>
    </router-link>

    <b-row v-if="!isMemberInfoLoading && memberInfo">
      <b-col col md="4">
        <!-- BEGIN Profile-->
        <div class="card overflow-hidden shadow ">
          <div class="bg-primary">
            <div class="text-primary p-3">
              <h5 class="text-white text-center">
                <i class="mdi mdi-hexagon-multiple-outline"></i>
                {{ memberInfo.workspace.name }}
              </h5>
              <div class="col-5 align-self-end"></div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col">
                <div class="avatar-md profile-user-wid mb-4">
                  <span
                    v-if="!memberInfo.avatar"
                    class="
                  avatar-title
                  rounded-circle
                  bg-warning
                  text-white
                  font-size-24
                "
                  >
                    {{ userLetterAvatar }}
                  </span>
                  <img v-else :src="memberInfo.avatar" alt class="img-thumbnail rounded-circle" />
                </div>
                <h5 class="font-size-15 text-truncate">{{ memberInfo.name }}</h5>
                <p class="text-muted mb-0 text-truncate">{{ memberInfo.email }}</p>
              </div>

              <div class="col ">
                <div class="pt-4">
                  <i class="mdi mdi-account-circle"></i>
                  <b>
                    {{ memberInfo.workspaceRole.name | translate }}
                  </b>
                  <div class="text-muted mt-2">
                    {{ memberInfo.workspaceRole.description | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Profile  -->
      </b-col>
      <b-col col md="8">
        <h5 class="mb-3">{{ $t("organization.user-can-access") }}</h5>

        <div v-for="acl in accessableOrganizations" :key="acl._id" class="border-top p-1 mb-1 bg-white p-2 border border-light hider">
          <b-row>
            <b-col md="1">
              <letter-avatar :name="acl.organization.name" :image="acl.organization.logo" variant="secondary" />
            </b-col>
            <b-col class="pt-2">
              {{ acl.organization.name }}
            </b-col>
            <b-col>
              <div v-for="role in acl.roles" :key="acl._id + role._id" class="mb-1">
                <span class="badge badge-light border border-secondary p-1 ml-1">
                  {{ role.name | translate }}
                </span>
              </div>
            </b-col>
            <b-col md="1" class="pt-2">
              <a v-if="hasRemovePermission" @click="setMemberOrganizationAcl(acl, false)" v-b-tooltip.hover :title="$t('organization.remove-access')">
                <i class="bx bx-x text-danger font-size-20 hand hidden"></i>
              </a>
            </b-col>
          </b-row>
        </div>

        <empty width="200px" v-if="accessableOrganizations && accessableOrganizations.length == 0" />

        <b-button variant="link" v-if="!showInaccessableOrganizations && inaccessableOrganizations.length > 0" @click="showInaccessableOrganizations = true">
          <i class="bx bx-pencil"></i> {{ $t("organization.add-access-title") }}
        </b-button>

        <div v-if="showInaccessableOrganizations && inaccessableOrganizations.length > 0" class="mt-4">
          <hr />
          <h5 class="mb-3">{{ $t("organization.user-cant-access") }}</h5>

          <div v-for="acl in inaccessableOrganizations" :key="acl._id" class="border-top p-1 mb-1 bg-white p-2 border border-light hider">
            <b-row>
              <b-col md="1">
                <letter-avatar :name="acl.organization.name" :image="acl.organization.logo" variant="secondary" />
              </b-col>
              <b-col class="pt-2">
                {{ acl.organization.name }}
              </b-col>
              <b-col md="1" class="pt-2">
                <a @click="setMemberOrganizationAcl(acl, true)" v-b-tooltip.hover :title="$t('organization.add-access')">
                  <i class="bx bx-plus text-success font-size-20 hand hidden"></i>
                </a>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <content-loading v-if="isMemberInfoLoading" />
  </div>
</template>

<script>
import ContentLoading from "../../components/common/content-loading.vue";
import Empty from "../../components/common/empty.vue";
export default {
  components: { ContentLoading, Empty },

  data() {
    return { showInaccessableOrganizations: false };
  },

  computed: {
    hasRemovePermission() {
      return true;
    },
    userLetterAvatar() {
      const arr = this.memberInfo.name?.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("").toUpperCase();
    },
    memberInfo() {
      return this.$store.getters["workspace/memberInfo"];
    },
    accessableOrganizations() {
      return this.memberInfo?.acls.filter((acl) => acl.accessable);
    },
    inaccessableOrganizations() {
      return this.memberInfo?.acls.filter((acl) => !acl.accessable);
    },
    isMemberInfoLoading() {
      return this.$store.getters["workspace/isMemberInfoLoading"];
    },
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch("workspace/fetchWorkspaceMemberInfo", this.$route.params.memberId);
    },
    async setMemberOrganizationAcl(acl, accessable) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`workspace/setMemberOrganizationAcl`, { aclId: acl._id, accessable });
        this.init();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
